module.exports = __webpack_public_path__ + "static/media/wapp.fde9b2db.png";